import Header from "../Header/Header";
import logo from "../../assets/logoa 1.png";
import { sendInquery } from "../../services/kojaServices";
import { toast } from "react-hot-toast";
import { useState , useEffect } from "react";
import { useSearchParams } from "react-router-dom";
const InQuery = () => {
  const [status,setStatus] = useState(false)
  const [result,setResult] = useState(false)
  const [serchParams,setserch] = useSearchParams()

  console.log(serchParams.get('requestToken'))

  useEffect(()=>{
    const fetchData = async()=>{
      if(serchParams.get('requestToken')){
        try{
          let inquery = serchParams.get('requestToken')
          if(inquery){
            const {data} = await sendInquery(inquery)
            console.log(data)
            setResult(data.result_message)
            setStatus(true)
          }else{
            toast.error('لطفا صورت کارشناسی را وارد کنید')
          }
    
        }catch(err){
          console.log(err)
          if(err.response.status === 404){
            toast.error(err.response.data.result_message)
          }else{
            toast.error("خطایی رخ داده است مجدد تلاش کنید")
          }
        }
      }
    }
fetchData()
  },[])

  const submitForm = async()=>{
    try{
      let inquery = document.getElementById('inquery').value
      if(inquery){
        const {data} = await sendInquery(inquery)
        console.log(data)
        setResult(data.result_message)
        setStatus(true)
      }else{
        toast.error('لطفا صورت کارشناسی را وارد کنید')
      }

    }catch(err){
      console.log(err)
      if(err.response.status === 404){
        toast.error(err.response.data.result_message)
      }else{
        toast.error("خطایی رخ داده است مجدد تلاش کنید")
      }
    }
  }
  return (
    <div>
      <Header />
      <div className="inquery">
        <div className="inquery-back1 d-none d-md-block">
          <div className="inquery-back2"></div>
        </div>

       {
        !status ? (
          <div className="user-login-box1 text-center">
          <img alt="" className="user-login-logo" src={logo} />
          <div className="user-login-box2">
            <h3 className="user-login-label">سامانه استعلام صورت کارشناسی</h3>
            <input
              placeholder="شماره صورت کارشناسی"
              className="userlogin-input"
              id="inquery"
            />
            <div className="user-login-btn-box">
              <button className="btn user-login-btn" onClick={()=> {submitForm()}}>استعلام</button>
            </div>
          </div>
        </div>
        ) : (
          <div className="user-login-box1 text-center">
          <img alt="" className="user-login-logo" src={logo} />
          <div className="user-login-box2">
            <h3 className="user-login-label">سامانه استعلام صورت کارشناسی</h3>
            <p>
            {result}
            </p>
          </div>
        </div>
        )
       }
      </div>
    </div>
  );
};

export default InQuery;
